import { gql } from "lib/apolloClient";

const aclFragments = {
  permissionBasicDetails: gql`
    fragment permissionBasicDetailsItem on ACLPermission {
      id
      uid
      value
    }
  `,
  featureFlagBasicDetails: gql`
    fragment featureFlagBasicDetailsItem on ACLFeatureFlag {
      id
      uid
      value
    }
  `,
  preferenceBasicDetails: gql`
    fragment preferenceBasicDetailsItem on ACLPreference {
      id
      uid
      value
      valueType
    }
  `,
};

//Temporary fragments which will be used till backward compatibility is not removed
export const configurationFragments = {
  basicDetails: gql`
    fragment configurationV2Item on ConfigurationV2 {
      id
      uidV2
      configuration
      valueType
      value
      isLocked
    }
  `,
};

export const projectGroupFragments = {
  basicDetails: gql`
    fragment projectGroupBasicDetailsItem on ProjectGroupCategory {
      id
      type
    }
  `,
  programDetails: gql`
    fragment projectGroupProgramDetailsItem on ProjectGroupCategory {
      id
      curriculumProgram {
        id
      }
    }
  `,
};

export default aclFragments;
